import { render, staticRenderFns } from "./Faq.vue?vue&type=template&id=3c6890c3&scoped=true&"
import script from "./Faq.vue?vue&type=script&lang=js&"
export * from "./Faq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6890c3",
  null
  
)

component.options.__file = "Faq.vue"
export default component.exports